<template>
  <div
    class="base"
    :class="{ 'modalActive': showModal }"
  >
    <Header :current-view="currentView" />
    <BreadCrumb />
    <TourCard
      v-if="userIsLogged"
      ref="tourCard"
    />
    <div class="main">
      <transition
        name="slide-fade"
        mode="out-in"
        @change="clearModalInfo"
      >
        <router-view
          @hook:mounted="startOnboarding"
        />
      </transition>
    </div>
    <component
      :is="showModal.name"
      v-if="showModal"
      class="base__modals"
    />
    <AppBannerSecondary v-if="!ishome" />
    <FooterLarge />
    <VLibras />
    <BotComponent />
    <RecaptchaComponent />
    <NormalizeCssComponent />
  </div>
</template>

<script>
// @ is an alias to /src
import Header from '@/components/common/Header.vue';
import ModalImg from '@/components/makeComplaint/ModalImg.vue';
import ModalUserData from '../components/common/ModalUserData.vue';
import BreadCrumb from '@/components/common/BreadCrumb.vue';
import TourCard from '@/components/onboardingComponents/TourCard.vue';
import { mapActions, mapGetters } from 'vuex';
import autoLogin from '@/mixins/autoLoginMixin';
import generateManifest from '@/mixins/generateManifestMixin';
import FooterLarge from '@/components/common/FooterLarge.vue';
import AppBannerSecondary from '../components/common/AppBannerSecondary.vue';

export default {
  name: 'Base',
  components: {
    Header,
    ModalImg,
    ModalUserData,
    BreadCrumb,
    TourCard,
    VLibras: () => import(/* webpackPrefetch: true */ '@/components/third-party/VLibrasComponent.vue'),
    BotComponent: () => import(/* webpackPrefetch: true */ '@/components/third-party/BotComponent.vue'),
    RecaptchaComponent: () => import(/* webpackPrefetch: true */ '@/components/third-party/RecaptchaComponent.vue'),
    NormalizeCssComponent: () => import(/* webpackPrefetch: true */ '@/components/third-party/NormalizeCssComponent.vue'),
    FooterLarge,
    AppBannerSecondary
},

  mixins: [
    autoLogin,
    generateManifest
  ],

  data(){
    return {
      currentView: 'Home',
    };
  },


  computed: {
    ...mapGetters([
      'userIsLogged',
      'userToken',
      'showModal',
      'showErrorModal'
    ]),
    ishome() {
      return this.currentView === 'Home';
    },
  },
  mounted(){
    this.currentView = this.$router.history.current.name;
  },
  updated(){
    this.currentView = this.$router.history.current.name;
  },
  methods: {
    ...mapActions([
      'initKeycloak',
      'clearModalToShow'
    ]),

    startOnboarding() {
      if(this.userIsLogged)
        this.$refs.tourCard.startTour();
    },

    clearModalInfo() {
      this.clearModalToShow();
    }
  },
};
</script>

<style lang="scss" scoped>
  .base {
    height: 100%;
    width: 100vw;

    &__modals {
      height: 100% !important;
    }

    @include screen (phone-only) {
      padding-bottom: 67px;
    }
  }

  .main {
    min-height: calc(100vh - 235px - 108px - 3rem);
  }

  .modalActive {
    height: 100vh !important;
    overflow: auto;
    overflow-y: hidden;
  }
</style>
